// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"7c416c81","564":"7c416c81","705":"7c416c81","946":"7c416c81"}[chunkId] + ".chunk.css";
};